var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9911 15.1597H9.87999V11.2152H5.9911V15.1597ZM11.0467 15.1597H12.4078C13.0782 15.1597 13.7211 14.8896 14.1952 14.4087C14.6692 13.9279 14.9355 13.2757 14.9355 12.5958V11.2152H11.0467V15.1597ZM14.9355 10.0318V6.08733H11.0467V10.0318H14.9355ZM14.9355 4.90397V3.5234C14.9355 2.8434 14.6692 2.19126 14.1952 1.71043C13.7211 1.2296 13.0782 0.959473 12.4078 0.959473H11.0467V4.90397H14.9355ZM9.87999 0.959473H5.9911V4.90397H9.87999V0.959473ZM0.935547 6.08733V10.0318H4.82444V6.08733H0.935547ZM0.935547 11.2152V12.5958C0.935547 13.2757 1.20187 13.9279 1.67592 14.4087C2.14997 14.8896 2.79292 15.1597 3.46332 15.1597H4.82444V11.2152H0.935547ZM9.87999 6.08733V10.0318H5.9911V6.08733H9.87999Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.a79b00e1a085d23c9a7be982c37113a6.svg";
export { ForwardRef as ReactComponent };